import { status, statusText } from '../constants'

const mappingStatus = Object.keys(status)
  .filter(key => key !== 'ALL')
  .map(key => ({
    value: key,
    text: statusText[key],
  }))
export default [
  [
    {
      id: 'code',
      label: 'รหัสเจ้าของรถ',
      type: 0,
      props: { margin: '0 8px 0 0', width: '100px', title: { text: 'รหัสเจ้าของรถ' } },
    }, {
      id: 'nameTh',
      label: 'ชื่อภาษาไทย',
      type: 0,
      props: { margin: '0 8px 0 0', title: { text: 'ชื่อภาษาไทย *' } },
    }, {
      id: 'nameEn',
      label: 'ชื่อภาษาอังกฤษ',
      type: 0,
      props: { margin: '0 8px 0 0', title: { text: 'ชื่อภาษาอังกฤษ *' } },
    }, {
      id: 'rate',
      label: 'ค่าธรรมเนียม',
      type: 0,
      valueType: 'float',
      props: { margin: '0 8px 0 0', title: { text: 'ค่าธรรมเนียม' } },
    }, {
      id: 'taxId',
      label: 'เลขที่ผู้เสียภาษี',
      type: 0,
      props: { margin: '0 8px 0 0', title: { text: 'เลขที่ผู้เสียภาษี' } },
    }, {
      id: 'type',
      label: 'ประเภทรถ *',
      type: 3,
      props: { padding: '0 0 18px 0' },
      title: { text: 'ประเภทรถ' },
      children: [
        { value: 'PADOONGRICH', text: 'รถของผดุงฤทธิ์' },
        { value: 'JOINTCAR', text: 'รถร่วมในเครือ' },
        { value: 'OUTJOINTCAR', text: 'รถร่วมนอก' },
      ],
    },
  ], [
    {
      id: 'description',
      label: 'รายละเอียด',
      type: 0,
      props: { margin: '0 40px 0 0', width: '240px', title: { text: 'รายละเอียด' } },
    },
  ],
]

export const initialdatamockup = [
  [
    {
      id: 'code',
      label: 'รหัส',
      type: 0,
      props: { margin: '0 8px 0 0', width: '60px', title: { text: 'ผู้จ้าง' } },
    }, {
      id: 'nameTh',
      lable: 'ชื่อภาษาไทย',
      type: 0,
      props: { margin: '0 32px 0 0' },
    }, {
      id: 'nameEn',
      label: 'Name',
      type: 2,
      props: { margin: '0 20px 0 0', padding: '0 0 8px 0' },
    }, {
      id: 'type',
      label: 'ประเภทรถ',
      type: 3,
      props: { padding: '0 0 8px 0' },
      children: [
        { value: 'PADOONGRICH', text: 'รถของผดุงฤทธิ์' },
        { value: 'JOINTCAR', text: 'รถร่วม' },
      ],
    },
  ], [
    {
      id: 4,
      label: 'ประเภทสินค้า',
      type: 0,
      props: { margin: '0 40px 0 0', width: '240px', title: { text: 'ประเภทสินค้า' } },
    }, {
      id: 5,
      label: 'น้ำหนักทั้งหมด',
      type: 0,
      props: { margin: '0 8px 0 0', width: '155px', title: { text: 'น้ำหนักทั้งหมด' } },
    }, {
      id: 6,
      value: 'กระสอบ',
      type: 3,
      children: mappingStatus,
    },
  ],
]
